/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-call */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-unsafe-return */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { $ } from "./$Element";
import { rune } from "./rune";
import { _camelToColonSeparated } from "./lib/_camelToColonSeparated";
export class EventHelper {
    _getMap(constructor) {
        return this._listenerMap.get(constructor) || this._listenerMap.set(constructor, new Map()).get(constructor);
    }
    getListener(param, fn) {
        let { constructor } = param;
        return this._getMap(constructor).get(fn);
    }
    setListener(param, fn, boundListener) {
        let { constructor } = param;
        return this._getMap(constructor).set(fn, boundListener);
    }
    _makeListener(instance, listener, View) {
        const fn = typeof listener === "string" ? instance[listener] : listener;
        const boundListener = this.getListener(instance, fn);
        if (boundListener) {
            return boundListener;
        } else {
            const boundListener = function(e) {
                const _instance = rune.get(this, instance.constructor);
                fn.call(_instance, e, typeof View === "string" || View === undefined ? _instance : rune.getUnknownView(e.currentTarget));
            };
            this.setListener(instance, fn, boundListener);
            return boundListener;
        }
    }
    _getReservedListener(instance) {
        var _this__reservedListenerMap_get;
        return (_this__reservedListenerMap_get = this._reservedListenerMap.get(instance)) !== null && _this__reservedListenerMap_get !== void 0 ? _this__reservedListenerMap_get : this._reservedListenerMap.set(instance, []).get(instance);
    }
    addReservedListener(instance, element) {
        this._getReservedListener(instance).forEach((f)=>f(instance, element));
        return this;
    }
    addEventListener(instance, element, eventType, listener, options) {
        if (element) {
            element.addEventListener(this._eventType(eventType), this._makeListener(instance, listener), options);
        } else {
            this._getReservedListener(instance).push((instance, element)=>{
                this.addEventListener(instance, element, eventType, listener, options);
            });
        }
        return this;
    }
    removeEventListener(instance, element, eventType, listener, options) {
        element.removeEventListener(this._eventType(eventType), this._makeListener(instance, listener), options);
        return this;
    }
    delegate(instance, element, eventType, selector, listener) {
        if (element) {
            $(element).delegate(this._eventType(eventType), typeof selector === "string" ? selector : ".".concat(selector, "[data-rune]"), this._makeListener(instance, listener, selector));
        } else {
            this._getReservedListener(instance).push((instance, element)=>this.delegate(instance, element, eventType, selector, listener));
        }
        return this;
    }
    _eventType(eventType) {
        return typeof eventType === "string" ? eventType : _camelToColonSeparated(eventType.name);
    }
    addDecoratedListeners(instance, element) {
        var _instance__decoratedListeners;
        (_instance__decoratedListeners = instance._decoratedListeners) === null || _instance__decoratedListeners === void 0 ? void 0 : _instance__decoratedListeners.forEach((f)=>f(instance, element));
        return this;
    }
    on(instancePrototype, eventType, listener, selector) {
        var _instancePrototype__decoratedListeners;
        instancePrototype._decoratedListeners = [
            ...(_instancePrototype__decoratedListeners = instancePrototype._decoratedListeners) !== null && _instancePrototype__decoratedListeners !== void 0 ? _instancePrototype__decoratedListeners : [],
            selector === undefined ? (instance, element)=>eventHelper.addEventListener(instance, element, eventType, listener) : (instance, element)=>eventHelper.delegate(instance, element, eventType, typeof selector === "string" ? selector : instance, listener)
        ];
    }
    constructor(){
        _define_property(this, "_listenerMap", new WeakMap());
        _define_property(this, "_reservedListenerMap", new WeakMap());
    }
}
export const eventHelper = new EventHelper();
